import { Box, Flex } from "@chakra-ui/react";

import { TapIcon } from "ui/Icons/Icons";
import { Shelf } from "ui/Shelf/Shelf";
import { TitleM } from "ui/Typography/Typography";
import { getShelfDetail } from "utils/item";

interface ShelfChangeCardProps {
  name: string;
  shelfFrom: string;
  isCompleted: boolean;
  onClick: () => void;
}

export function ShelfChangeCard({ name, shelfFrom, isCompleted, onClick }: ShelfChangeCardProps) {
  const { shelfNumber: number, shelfLetter: letter } = getShelfDetail(shelfFrom);

  return (
    <Flex
      position="relative"
      align="center"
      gap="s100"
      w="100%"
      h="102px"
      p="s200"
      bg="white"
      onClick={onClick}
    >
      {isCompleted && (
        <>
          <Box width="8px" h="100%" pos="absolute" top={0} left={0} bg="veggie.500" />
          <TapIcon h="24px" w="24px" />
        </>
      )}

      <TitleM color="grey.800" noOfLines={3} flex="1" pl="s100">
        {name}
      </TitleM>

      <Shelf letter={letter} number={number} />
    </Flex>
  );
}
